<div class="complementary-product-filter-container">
  <div class="return-button-container">
    <ng-casto-button class="secondary" [label]="'Fermer les filtres'"
                     (click)="isOpenChange.emit(false)"></ng-casto-button>
  </div>

  <div class="title">
    <span>Filtres par catégories</span>
    <ng-casto-button class="action" [faIcon]="faRedo" (click)="setDefaultSubCategories()"></ng-casto-button>
  </div>


  <div class="categories-container">
    <p-tree [value]="categories"
            selectionMode="checkbox"
            [(selection)]="selectedFilters"
            (onNodeSelect)="onNodeSelect($event.node)">
      <ng-template pTemplate="default" let-node>
        <span>
          {{ node.label }}
          @if (node.children && getNodeChildrenEnabledCount(node) > 0) {
            {{ '(' + getNodeChildrenEnabledCount(node) + ')' }}
          }
        </span>
      </ng-template>
    </p-tree>
  </div>
</div>
